import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { CardsTableProps } from 'components/CardsTable/types';
import InfoTooltip from 'components/InfoTooltip/InfoTooltip';
import './CardsTableColumnsHead.css';
import CardsTableHeadArrowUp from './svgs/CardsTableHeadArrowUp';
import CardsTableHeadArrowDown from './svgs/CardsTableHeadArrowDown';

export const CardsTableColumnsHead = ({
  cellsData,
  orderBy,
  order,
  rowDividerType = 'color-mix',
  onHeaderSortPress,
  isAllSelected,
  isIndeterminate,
  onSelectAll,
}: CardsTableProps) => {
  const isColorMix = rowDividerType === 'color-mix';
  const onSortLabelPress = (key: string) => {
    if (onHeaderSortPress) onHeaderSortPress(key);
  };
  return (
    <TableRow>
      {cellsData.headCells.map((headCell) => {
        const isArrowUpSelected = headCell.key === orderBy && order === 'desc';
        const isArrowDownSelected = headCell.key === orderBy && order === 'asc';
        const sortComponent = headCell.noSort
          ? undefined
          : () => (
              <div className="collection-card-sort-icons-container">
                <CardsTableHeadArrowUp isSelected={isArrowUpSelected} />
                <CardsTableHeadArrowDown isSelected={isArrowDownSelected} />
              </div>
            );
        return (
          <TableCell
            key={headCell.key}
            sortDirection={orderBy === headCell.label ? order : false}
            align="left"
            sx={(theme) => ({
              border: !isColorMix ? '1px' : 0,
              backgroundColor: theme.colors.black,
              width: headCell.columnWidth,
            })}
          >
            {headCell.key === 'batch-select' ? (
              <input
                type="checkbox"
                className="batch-select-header-checkbox"
                ref={(el) => { if (el) el.indeterminate = !!isIndeterminate; }}
                checked={!!isAllSelected}
                onChange={() => onSelectAll?.()}
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <>
                <TableSortLabel
                  active
                  sx={(theme) => ({
                    color: theme.colors.white,
                    fontWeight: 'bold',
                    fontSize: 11,
                    ':active': { color: theme.colors.white },
                    ':hover': { color: theme.colors.white },
                    '&.Mui-active': {
                      color: { color: theme.colors.white }, // color when sorted
                    },
                  })}
                  IconComponent={sortComponent}
                  onClick={() => onSortLabelPress(headCell.key)}
                >
                  {headCell.label}
                </TableSortLabel>
                {/* Tooltip sits outside the sort label so hovering it never triggers a sort. */}
                {headCell.headerTooltip && (
                  <InfoTooltip text={headCell.headerTooltip} placement="bottom" />
                )}
              </>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};
